import { useContext } from 'react'
import { LanguageContext } from './App'
import translations from './translations.json'

// Look up translation and if it exists, return it. Otherwise just return the (english) text
export default function useTranslation(text) {

    const language = useContext(LanguageContext)

    if (translations[language][text]) {
        return translations[language][text]
    }

    return text
}